module.exports = __webpack_public_path__ + "static/media/cluster_10.2b386a79.webp";